import { render, staticRenderFns } from "./RolesTableCrud.vue?vue&type=template&id=6e298fa4&"
import script from "./RolesTableCrud.vue?vue&type=script&lang=js&"
export * from "./RolesTableCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports